import React, { useEffect, useRef, useState } from "react";
import { Box, IconButton } from "@material-ui/core";
import LaunchIcon from "@material-ui/icons/Launch";

// Styles
import useStyles from "./styles";

function CustomDocumentViewer({ documentUrl, width, height, document }) {
  const styles = useStyles();
  const [isImage, setIsImage] = useState(false);
  const [isVideo, setIsVideo] = useState(false);

  const mediaRef = useRef(null);

  const getGoogleDocURL = (url) =>
    `https://docs.google.com/gview?url=${url}&embedded=true`;

  const getFileExtension = () => {
    const docName = document?.fileName || document?.documentName || "";
    const extension = docName.split(".").pop()?.toLowerCase();
    const imageExtensions = ["png", "jpg", "jpeg", "gif", "bmp", "webp", "svg"];
    const videoExtensions = ["mp4", "webm", "ogg", "mov", "avi", "mkv", "flv"];

    setIsImage(imageExtensions.includes(extension));
    setIsVideo(videoExtensions.includes(extension));
  };

  useEffect(() => {
    getFileExtension();
  }, [documentUrl]);

  const handleFullScreen = () => {
    const elem = mediaRef.current;
    if (elem) {
      if (elem.requestFullscreen) elem.requestFullscreen();
      else if (elem.webkitRequestFullscreen) elem.webkitRequestFullscreen();
      else if (elem.mozRequestFullScreen) elem.mozRequestFullScreen();
      else if (elem.msRequestFullscreen) elem.msRequestFullscreen();
    }
  };

  const renderOpenInNewTabIcon = () => (
    <IconButton
      onClick={handleFullScreen}
      style={{
        position: "absolute",
        top: 8,
        right: 8,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        color: "#fff",
        zIndex: 2,
      }}
    >
      <LaunchIcon fontSize="small" />
    </IconButton>
  );

  return (
    <>
      {!isImage && !isVideo ? (
        <Box className={styles.iframeWrapper}>
          <iframe
            src={getGoogleDocURL(documentUrl)}
            width={width}
            height={height}
            className={styles.iframeStyle}
            title="Document Viewer"
            allowFullScreen
          />
        </Box>
      ) : (
        <Box
          style={{
            width,
            height,
            position: "relative",
            overflow: "hidden",
            borderRadius: 4,
          }}
        >
          {renderOpenInNewTabIcon()}
          {isImage ? (
            <Box className={styles.imageWrapper}>
              <img
                ref={mediaRef}
                src={documentUrl}
                alt="Preview"
                style={{ width: "100%", height: "100%", objectFit: "contain" }}
                className={styles.imageStyle}
              />
            </Box>
          ) : (
            <video
              ref={mediaRef}
              src={documentUrl}
              controls
              style={{ width: "100%", height: "100%", objectFit: "contain" }}
              className={styles.videoStyle}
            />
          )}
        </Box>
      )}
    </>
  );
}

export default CustomDocumentViewer;
